import { ColorRecipeModel } from '../../models/color-recipe.model';

export class SetColorRecipe {
  static readonly type = '[Edit Paint] Set Color Recipe';
  constructor(public colorRecipe: ColorRecipeModel) { }
}

export class ClearColorRecipe {
  static readonly type = '[Edit Paint] Clear Color Recipe';
  constructor() { }
}

export class ResetPaint {
  static readonly type = '[Edit Paint] Reset Paint';
  constructor() { }
}
